<ng-container *ngIf="isContractor; else clientTemplate">
  <app-contractor></app-contractor>
</ng-container>

<ng-template #clientTemplate>
  <app-client></app-client>
</ng-template>
